export default "__VITE_ASSET__CQTxvpyT__"